import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { LoadingSpinnerService } from './loading-spinner.service';
import { Observable } from 'rxjs';
import { LoadingSpinnerState } from './loading-spinner.model';

@Component({
  selector: 'app-loading-spinner',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './loading-spinner.component.html',
  styleUrl: './loading-spinner.component.scss',
})
export class LoadingSpinnerComponent implements OnInit {
  isLoading:Observable<LoadingSpinnerState>;
  constructor(private loadingSpinnerService: LoadingSpinnerService){

  }

  ngOnInit(){
    this.isLoading = this.loadingSpinnerService.isLoading;
  }

}
